import React, { useEffect, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;

  .MuiAutocomplete-root {
    input.MuiAutocomplete-input {
      font-weight: 100;
      color: var(--Text-Primary) !important;
      font-family: "AllianceNo2-SemiBold" !important;
    }

    .MuiAutocomplete-inputRoot:before {
      border-bottom-color: #ddd !important;
      border-bottom: 1px solid var(--title-color) !important; 
    }
  }

  .MuiAutocomplete-popper {
    ul li {
      font-family: AllianceNo2-SemiBold;
      font-weight: 100;
      color: var(--Text-Primary) !important;
      font-weight: 400;
    }
  }

  .MuiAutocomplete-endAdornment button {
    color: var(--Text-Primary) !important;
    &:hover {
      background: transparent;
    }
  }
`;

const IconContainer = styled.div`
  font-family: AllianceNo2-SemiBold;
  font-weight: 100;
  padding-right: 10px;

  i {
    font-size: 18px;
    color: var(--Text-Primary);
  }
`;

const doesNothing = () => {};

const SelectAutocomplete = ({
  className = "",
  disabled = false,
  icon = null,
  name = "",
  title = "",
  selected = null,
  options = [],
  onChange = doesNothing,
  disableUnderLine = true,
  inForm = false,
}) => {
  const [value, setValue] = useState(options[0]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if(selected){
      const optionFound = options.find(option => option.value === selected);
      if(optionFound){
        setValue(optionFound);
      }
    }
  }, [options.length, selected])

  return (
    <Wrapper className={`${className}`}>
      {icon ? (
        <IconContainer title={title || name}>
          <i className="material-icons">{icon}</i>
        </IconContainer>
      ) : null}
      <Autocomplete
        name={name}
        value={value}
        onChange={(event, newValue) => {
          if (newValue !== null) {
            setValue(newValue);
            onChange(newValue.value);
          }
        }}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        disablePortal
        options={options}
        sx={{ width: "100%",  fontFamily: "AllianceNo2-SemiBold !important", }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            sx={{ width: "100%", fontSize: "12px", fontWeight: 400,  fontFamily: "AllianceNo2-SemiBold !important", }}
          />
        )}
      />
      { inForm !== true ? null :
        <input type="hidden" name={name} value={value.value} />
      }
    </Wrapper>
  );
};

export default SelectAutocomplete;
